@if (address(); as address) {
  <onyx-address
    [address]="address"
    [format]="format()"
    [showFlag]="showFlag()"
  ></onyx-address>
} @else {
  -
}
